import React from 'react'
import { SortableHandle } from 'react-sortable-hoc'
import { DragHandle } from '@material-ui/icons'
import { IGroupDetailed } from '../../../types/group'
import * as date from '../../../services/date'
import { H3, P } from '../../../components'
import { StyledRow } from './styled'

const DragHandler = SortableHandle(DragHandle)

interface IOrderTableRow {
  group: IGroupDetailed
}

export const ReorderTableRow: React.FC<IOrderTableRow> = ({ group }) => (
  <StyledRow key={group.name}>
    <td className="drag-handler">
      <DragHandler />
    </td>
    <td>
      <div>
        <H3>{group.shortTitle}</H3>
        <P>{group.title}</P>
      </div>
    </td>
    <td />
    <td>
      <P>{date.calendar(group.modified || group.created)}</P>
    </td>
    <td />
  </StyledRow>
)
